document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);
  if (typeof ScrollToPlugin !== 'undefined') gsap.registerPlugin(ScrollToPlugin);

  (function () {
    const hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (e) { return; }
    if (!target) return;

    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);

    window.addEventListener('load', () => {
      ScrollTrigger.refresh();
      requestAnimationFrame(() => {
        const el = document.getElementById(decodeURIComponent(hash.slice(1)));
        if (!el) return;
        const y = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset);
        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || typeof ScrollToPlugin === 'undefined') {
          window.scrollTo(0, y);
        } else {
          gsap.to(window, { duration: 0.9, ease: 'power2.inOut', scrollTo: { y, autoKill: false } });
        }
      });
    });
  })();

  document.querySelectorAll('[data-animate="fade-up"]').forEach((el) => {
    const delay = parseFloat(el.dataset.delay) || 0;

    gsap.from(el, {
      y: 40,
      opacity: 0,
      duration: 0.8,
      delay,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: el,
        start: 'top 85%',
        once: true,
      },
    });
  });

  document.querySelectorAll('[data-animate="fade-left"]').forEach((el) => {
    gsap.from(el, {
      x: 60,
      opacity: 0,
      duration: 1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: el,
        start: 'top 85%',
        once: true,
      },
    });
  });

  const marquee = document.querySelector('[data-marquee]');
  if (marquee) {
    const items = Array.from(marquee.children);
    items.forEach((item) => marquee.appendChild(item.cloneNode(true)));

    gsap.to(marquee, {
      xPercent: -50,
      duration: 20,
      ease: 'none',
      repeat: -1,
    });
  }

  const header = document.querySelector('[data-header]');
  if (header) {
    ScrollTrigger.create({
      start: 'top -80',
      onUpdate: (self) => {
        header.classList.toggle('scrolled', self.progress > 0);
      },
    });
  }
});

document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href]');
  if (!link || link.target === '_blank') return;

  let url;
  try { url = new URL(link.href, window.location.href); } catch (err) { return; }
  if (url.host !== window.location.host || url.pathname !== window.location.pathname || !url.hash) return;

  const id = decodeURIComponent(url.hash.slice(1));
  const target = id && document.getElementById(id);
  if (!target) return;

  e.preventDefault();

  const y = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset);
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasGsap = typeof gsap !== 'undefined';
  const hasScrollTo = hasGsap && typeof ScrollToPlugin !== 'undefined';

  if (reduce || !hasGsap) {
    window.scrollTo(0, y);
  } else if (hasScrollTo) {
    gsap.to(window, {
      duration: 0.9,
      ease: 'power2.inOut',
      scrollTo: { y, autoKill: true },
    });
  } else {
    const proxy = { y: window.pageYOffset };
    gsap.to(proxy, {
      y,
      duration: 0.8,
      ease: 'power2.inOut',
      onUpdate: () => window.scrollTo(0, proxy.y),
    });
  }

  if (window.history && window.history.pushState) {
    window.history.pushState(null, '', url.hash);
  }
});
